import React, { useMemo } from 'react';
import { TreeSelect } from 'antd';

const titleStyle = {
  display: 'block',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};

const buildTreeData = folders =>
  folders.map(folder => ({
    title: (
      <span style={titleStyle} title={folder.name}>
        {folder.name}
      </span>
    ),
    value: folder.id,
    key: folder.id,
    name: folder.name,
    ...(folder.children && folder.children.length > 0
      ? { children: buildTreeData(folder.children) }
      : {})
  }));

const FolderSelect = ({ folders, t, value, onChange, placeholder, ...props }) => {
  const treeData = useMemo(() => {
    const sorted = [...folders].sort((a, b) => {
      if (a.name === 'Por defecto') return 1;
      if (b.name === 'Por defecto') return -1;
      return a.name.localeCompare(b.name, undefined, { sensitivity: 'base' });
    });

    const tree = buildTreeData(sorted);
    const allLabel = t('All') || 'Todos';
    tree.unshift({
      title: <span style={titleStyle}>{allLabel}</span>,
      value: null,
      key: '__all__',
      name: allLabel
    });
    return tree;
  }, [folders, t]);

  const handleChange = (val, labelList) => {
    const key = val === null || val === undefined ? null : String(val);
    onChange({ key, label: labelList[0] || '' });
  };

  const filterTreeNode = (input, node) =>
    node.props.name ? node.props.name.toLowerCase().includes(input.toLowerCase()) : false;

  const treeValue = (() => {
    if (!value || value.key === null || value.key === undefined) return null;
    const n = Number(value.key);
    return isNaN(n) ? null : n;
  })();

  return (
    <TreeSelect
      style={{ width: 200 }}
      placeholder={placeholder || t('Select a folder')}
      showSearch
      filterTreeNode={filterTreeNode}
      treeData={treeData}
      value={treeValue}
      onChange={handleChange}
      dropdownStyle={{ maxHeight: 400, maxWidth: 280, overflow: 'auto' }}
      {...props}
    />
  );
};

export default FolderSelect;
